export default __webpack_public_path__ + "static/media/engraved.520efff2.png";